export enum Period {
  PAST = 'past',
  NEXT = 'next',
  CANCELED = 'canceled'
}
